onDomLoad(($dom) => {
  $dom.find("[data-behaviour='add-confirmation-modal']").each((index, el) => {
    el.addEventListener('click', () => {
      const modalParams = {
        entityName: el.dataset.entityName || '',
        marketPackageNames: el.dataset.marketPackageNames || '',
        successUrl: el.dataset.url || '',
        submitMethod: el.dataset.submitMethod || '',
      }

      window.modalCitizen.openModalPortal(
        'enable-market-package-confirmation-modal',
        modalParams
      )
    })
  })
})
